export const Colors = {
  background: {
    header: '#2F185A',
    DEFAULT: '#ffffff',
    gradient: '#F5F0FF',
    variant: '#F5F0FF',
    grey: '#F5F0FF',
    dark: '#F5F0FF',
  },
  backgroundGradientBase: '#ffffff',
  backgroundGradientVariant: '#ffffff',
  headerIcons: '#ffffff',
  cardBackground: '#F7F9FE',
  foreground: '#000000',
  section: '#F5F0FF',
  footer: '#2F185A',
  badge: '#24CFA4',
  footerText: '#ffffff',
  highlight: '#2F185A',
  currencyColor: {
    DEFAULT: '#2F185A',
  },
  primary: {
    DEFAULT: '#8B5CF6',
    hover: '#7C3AED',
    text: '#8B5CF6',
    foreground: '#ffffff',
  },
  secondary: {
    DEFAULT: '#77158E',
    hover: '#8B5CF6',
    text: '#A78BFA',
    foreground: '#ffffff',
    variant: '#A78BFA',
  },
  tertiary: {
    DEFAULT: '#24CFA4',
    hover: '#16E0AD',
    text: '#000000',
    foreground: '#000000',
    variant: '#24CFA4',
  },
  success: '#22c55e',
  error: '#ef4444',
  accent: {
    DEFAULT: '#8B5CF6',
    foreground: '#000000',
  },
  quantitySelectorBorder: 'rgba(139, 92, 246, 0.1)',
};
